import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import config from '../config';
import Textarea from '../Textarea';
import Input from '../Input';
import Popover from '../Popover';
import { editableAreaClass } from './styles';
import icons from '../icons';
import { focusElement, getParent } from '../utils/dom/element';
import { inputClass } from '../Input/styles';
import InputTitle from '../InputTitle';
import { inputTitleClass } from '../InputTitle/styles';
var DefaultProps = {
  bordered: false
};

var noop = function noop() {};

function formatShowValue(value) {
  if (!value && value !== 0) return '';
  var arr = String(value).split('\n');
  var len = arr.length;
  if (len > 1) return "".concat(arr[0], "...");
  return String(value);
}

var Editable =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Editable, _React$PureComponent);

  var _super = _createSuper2(Editable);

  function Editable(props) {
    var _this;

    _classCallCheck(this, Editable);

    _this = _super.call(this, props);
    _this.bindContainer = void 0;
    _this.bindInput = void 0;
    _this.container = void 0;
    _this.input = void 0;
    _this.showPop = void 0;
    _this.hidePop = void 0;
    _this.handleClear = void 0;
    _this.width = void 0;
    _this.state = {
      showTextarea: false
    };
    _this.bindContainer = _this.bindElement.bind(_assertThisInitialized(_this), 'container');
    _this.bindInput = _this.bindElement.bind(_assertThisInitialized(_this), 'input');
    _this.renderInput = _this.renderInput.bind(_assertThisInitialized(_this));
    _this.renderPlace = _this.renderPlace.bind(_assertThisInitialized(_this));
    _this.renderTextarea = _this.renderTextarea.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.autoFocus = _this.autoFocus.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.showPop = _this.updateShowTextarea.bind(_assertThisInitialized(_this), true);
    _this.hidePop = _this.updateShowTextarea.bind(_assertThisInitialized(_this), false);
    _this.handleClear = _this.onChange.bind(_assertThisInitialized(_this), '');
    return _this;
  }

  _createClass(Editable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      var showTextarea = this.state.showTextarea;

      if (prevState.showTextarea !== showTextarea && showTextarea) {
        this.autoFocus();
      }
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      var onChange = this.props.onChange;
      if (typeof onChange === 'function') onChange(value);
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var _this$props = this.props,
          onBlur = _this$props.onBlur,
          forceChange = _this$props.forceChange;
      var target = e.target;
      this.hidePop();
      var newValue = target.value;

      if (this.getTrim()) {
        newValue = newValue.trim();
        target.value = newValue;
      }

      forceChange(newValue);
      if (typeof onBlur === 'function') onBlur(e);
    }
  }, {
    key: "getTrim",
    value: function getTrim() {
      var trim = this.props.trim;
      if (trim !== undefined) return trim;
      if (config.trim !== undefined) return config.trim;
      return false;
    }
  }, {
    key: "getErrorProps",
    value: function getErrorProps() {
      var p = {};
      if ('error' in this.props) p.error = this.props.error;
      return p;
    }
  }, {
    key: "updateShowTextarea",
    value: function updateShowTextarea(flag) {
      if (flag && this.input) {
        this.width = getParent(this.input, ".".concat(editableAreaClass('input'))).offsetWidth;
      }

      this.setState({
        showTextarea: flag
      });

      if (this.props.onShowTextareaChange) {
        this.props.onShowTextareaChange(flag);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      var onFocus = this.props.onFocus;
      if (typeof onFocus === 'function') onFocus(e);
    }
  }, {
    key: "bindElement",
    value: function bindElement(type, el) {
      this[type] = el;
    }
  }, {
    key: "autoFocus",
    value: function autoFocus() {
      if (!this.container) return;
      var target = this.container.querySelector(".".concat(editableAreaClass('text-area'), " textarea.so-input-auto-size"));
      if (target) focusElement.end(target);
    }
  }, {
    key: "renderTextarea",
    value: function renderTextarea() {
      var showTextarea = this.state.showTextarea;
      var _this$props2 = this.props,
          placeholder = _this$props2.placeholder,
          maxHeight = _this$props2.maxHeight,
          value = _this$props2.value,
          innerTitle = _this$props2.innerTitle,
          placeTitle = _this$props2.placeTitle,
          renderFooter = _this$props2.renderFooter;
      if (!showTextarea) return null;
      var addTitleProps = {
        innerTitle: innerTitle,
        placeTitle: placeTitle
      };
      return (
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindContainer
        },
        /*#__PURE__*/
        React.createElement(Textarea, Object.assign({
          className: editableAreaClass('text-area'),
          autosize: true
        }, addTitleProps, {
          value: value,
          rows: 1,
          delay: 0,
          onChange: this.onChange,
          onBlur: this.onBlur,
          onFocus: this.handleFocus,
          placeholder: placeholder,
          maxHeight: maxHeight,
          renderFooter: renderFooter
        }, this.getErrorProps())))
      );
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      var _this$props3 = this.props,
          placeholder = _this$props3.placeholder,
          disabled = _this$props3.disabled,
          value = _this$props3.value,
          renderResult = _this$props3.renderResult,
          placeTitle = _this$props3.placeTitle,
          innerTitle = _this$props3.innerTitle,
          error = _this$props3.error;
      var result = renderResult(value);
      return (
        /*#__PURE__*/
        React.createElement("div", {
          tabIndex: disabled ? undefined : 0,
          className: classnames(editableAreaClass('input'), inputClass('_', error && 'invalid', disabled && 'disabled')),
          onFocus: this.showPop
        },
        /*#__PURE__*/
        React.createElement(InputTitle, {
          placeTitle: placeTitle,
          innerTitle: innerTitle,
          open: !!value
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(inputClass('spare'), innerTitle && inputTitleClass('hidable', 'item')),
          ref: this.bindInput
        }, result ||
        /*#__PURE__*/
        React.createElement("div", {
          className: inputClass('placeholder')
        }, placeholder ||
        /*#__PURE__*/
        React.createElement("br", null)))))
      );
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props4 = this.props,
          placeholder = _this$props4.placeholder,
          disabled = _this$props4.disabled,
          value = _this$props4.value,
          innerTitle = _this$props4.innerTitle,
          placeTitle = _this$props4.placeTitle;
      return (
        /*#__PURE__*/
        React.createElement(Input, Object.assign({
          innerTitle: innerTitle,
          placeTitle: placeTitle,
          forwardedRef: this.bindInput,
          placeholder: placeholder,
          value: formatShowValue(value),
          onChange: noop,
          className: editableAreaClass('input'),
          onFocus: this.showPop,
          disabled: disabled
        }, this.getErrorProps()))
      );
    }
  }, {
    key: "renderPlace",
    value: function renderPlace() {
      var renderResult = this.props.renderResult;

      if (renderResult && typeof renderResult === 'function') {
        return this.renderResult();
      }

      return this.renderInput();
    }
  }, {
    key: "render",
    value: function render() {
      var showTextarea = this.state.showTextarea;
      var _this$props5 = this.props,
          width = _this$props5.width,
          style = _this$props5.style,
          className = _this$props5.className,
          bordered = _this$props5.bordered,
          clearable = _this$props5.clearable,
          getPopupContainer = _this$props5.getPopupContainer,
          value = _this$props5.value;
      var cls = classnames(className, editableAreaClass('_', !bordered && 'none-bordered'));
      var ms = Object.assign({
        width: width
      }, style);
      var popStyle = {
        width: this.width
      };
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: cls,
          style: ms
        }, this.renderPlace(),
        /*#__PURE__*/
        React.createElement(Popover, {
          visible: showTextarea,
          showArrow: false,
          className: editableAreaClass('popover'),
          position: "cover",
          style: popStyle,
          getPopupContainer: getPopupContainer
        }, this.renderTextarea()), clearable && value ?
        /*#__PURE__*/
        React.createElement("div", {
          className: editableAreaClass('clear'),
          onClick: this.handleClear
        }, icons.CloseCircle) : null)
      );
    }
  }]);

  return Editable;
}(React.PureComponent);

Editable.defaultProps = DefaultProps;
export default Editable;